import { Component, OnInit } from '@angular/core';

import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'app-typeadd',
  templateUrl: './typeadd.component.html',
  styleUrls: ['./typeadd.component.css']
})
export class TypeaddComponent implements OnInit {

  IdMax = 0;
  NameType: any;
  NameMetaDescription;
  NameMetaKeyword;
  NameTitle;
  constructor(private af: AngularFireDatabase, private firebaseApp: FirebaseApp) {
    let snap = this.af.list('Menu');
    snap.subscribe((snapitem) => {
      snapitem.forEach(sn => {
        if (sn.Id > this.IdMax) {
          this.IdMax = sn.Id
        }
      })
      console.log(this.IdMax)

    })

  }

  ngOnInit() {

  }

  clickAdd() {
    let idd = Number(this.IdMax) + 1;
    let Item = {
      Id: idd,
      Name: this.NameType,
      MetaDescript:this.NameMetaDescription,
      MetaKeywords:this.NameMetaKeyword,
      Title:this.NameTitle
    }
    if (this.NameType != "") {
      let addType = this.af.list('Menu')
      addType.push(Item).then(res => {
        alert("เพิ่ม เสร๊จสิ้น")
        location.reload();
      })
    }else{
      alert("ข้อมูลไม่ถูกต้อง")
    }

  }

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/typepage/view/typeadd/typeadd.component.ts